/*
 * @描叙: 定时管理 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-21 09:50:09 
*/
import Service from '@/api/Service'

const timingControl = {
    state: {
        timeDesc: {},   //  定时控制表单
        settingTime: {},    //  定时控制时间
        timeControlMeters: {},  //  定时控制对象
        timeControlForm: {},    //定时控制参数
        timeKind: {},   //  定时分类

        meterGroupList: [], //分组列表
    },
    mutations: {
        SET_DESC: (state, desc) => {
            state.timeDesc = desc
        },
        SET_TIME: (state, settingTime) => {
            state.settingTime = settingTime
        },
        SET_CONTROLMETERS: (state, timeControlMeters) => {
            state.timeControlMeters = timeControlMeters
        },
        SET_CONTROLFORM: (state, timeControlForm) => {
            state.timeControlForm = timeControlForm
        },
        SET_TIEMKIND: (state, timeKind) => {
            state.timeKind = timeKind
        },
        SET_METERGROUP: (state, meterGroupList) => {
            state.meterGroupList = meterGroupList
        },
    },
    actions: {
        // 设置定时控制表单
        setTimeDesc({ commit }, form) {
            return new Promise((resolve, reject) => {
                resolve(form);
                commit('SET_DESC', form);
            })
			
        },
        // 设置定时控制时间
        settingTime({ commit }, form) {

            return new Promise((resolve, reject) => {
                resolve(form);
                commit('SET_TIME', form);
            })
        },
        // 定时控制对象
        setControlMeters({ commit }, form) {
            return new Promise((resolve, reject) => {
                resolve(form);
                commit('SET_CONTROLMETERS', form);
            })
        },
        // 定时控制参数
        setControlForm({ commit }, form) {
            return new Promise((resolve, reject) => {
                commit('SET_CONTROLFORM', form);
                resolve(form);
            })
        },
        // 定时分类
        async getTimerKind({ commit },) {
            let data = await Service.getTimerKind();
            data = data === 'success' ? [] : data
            
            return new Promise((resolve, reject) => {
                if (data.length > 0) {
                    resolve(data[0]);
                    commit('SET_TIEMKIND', data[0]);
                }else{
                    reject(false)
                }
            })
        },
        // 分组
        async getMeterGroupList({ commit }) {
            let data = await Service.getMeterGroupList();
            data = data === 'success' ? [] : data;

            return new Promise((resolve) => {
                resolve(data);
                commit('SET_METERGROUP', data);
            })
        }
    }
}

export default timingControl
